import React from 'react';

const VARIANT_CLASS = {
    success: 'btn--success',
    danger: 'btn--danger',
    warning: 'btn--warning',
    view: 'btn--view',
    secondary: 'btn--secondary',
    primary: 'btn--primary'
};

const SIZE_CLASS = {
    sm: 'small',
    md: ''
};

function DashboardButton({
    variant = 'primary',
    size = 'md',
    className = '',
    type = 'button',
    children,
    ...rest
}) {
    const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
    const sizeClass = SIZE_CLASS[size] || '';
    const finalClassName = ['btn', variantClass, sizeClass, className].filter(Boolean).join(' ');

    return (
        <button type={type} className={finalClassName} {...rest}>
            {children}
        </button>
    );
}

export default DashboardButton;
